<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-form ref="form" onsubmit="return false;">
        <v-text-field
        id="title"
        :label="$t('screener.save.form.screener_title')"
        name="title"
        :rules="[
            rules.required,
            rules.min_length(3),
            rules.max_length(250),
        ]"
        counter="250"
        color="primary"
        prepend-icon="$vuetify.icons.rms_agreement"
        type="text"
        v-model="screener.title['en']"
        >
        </v-text-field>
        <!-- FOR Event -->
        <template v-if="!is_vod_event">
          <DateTimePicker
          key="screening_starts_at"
          :label="$t('screener.save.form.starts_at')"
          datetime="screening_starts_at"
          v-model="screener.screening_starts_at"
          />
          <!-- Showing local time regarding company configured timezone -->
          <ShowLocalTime
          v-if="screener.screening_starts_at"
          key="screening_starts_at_local"
          :datetime="screener.screening_starts_at"
          :timezone="timezone"
          ></ShowLocalTime>

          <DateTimePicker
          key="screening_ends_at"
          :label="$t('screener.save.form.ends_at')"
          datetime="screening_ends_at"
          v-model="screener.screening_ends_at"
          />
          <!-- Showing local time regarding company configured timezone -->
          <ShowLocalTime
          v-if="screener.screening_ends_at"
          key="screening_ends_at_local"
          :datetime="screener.screening_ends_at"
          :timezone="timezone"
          ></ShowLocalTime>
        </template>
        <!-- For VOD -->
        <template v-else>
          <v-text-field
          id="vod_availability"
          :label="$t('vod.save.form.input.label.availability')"
          name="vod_availability"
          :rules="[
              rules.required,
              rules.numeric,
          ]"
          color="primary"
          prepend-icon="$vuetify.icons.rms_agreement"
          type="number"
          v-model="screener.vod_availability"
          ></v-text-field>
        </template>
      </v-form>
    </v-flex>
    <v-flex xs12 class="mt-5">
      <v-layout row wrap>
        <v-flex xs4 class="text-md-left">
          <v-btn v-if="!is_vod_event" class="ml-0" color="customPrimary customBackground--text" outline @click="$emit('onBack',2)">
            <v-icon small class="px-1">$vuetify.icons.screener_back</v-icon>
            {{ $t("screener.btn.back") }}
          </v-btn>
        </v-flex>
        <v-flex xs8 class="text-md-right">
          <v-btn class="ml-0" color="customPrimary customBackground--text" outline @click.prevent="onCancel">{{
            $t("rms.button.cancel")
          }}</v-btn>
            <v-btn class="mr-0" color="primary"  :loading="loading" :disabled="loading" outline @click.prevent="onCreate">{{
            $t("film.delivery_profile.button.create")
          }}</v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import rules from "@/validation";
import DateTimePicker from "@/components/DateTimePicker";
import ShowLocalTime from "@/components/ShowLocalTime";
import { mapGetters } from "vuex";

export default {
  name:"CreateScreenerAskBasicDetails",
  props:{
    is_vod_event: {
      type: Boolean,
      default: false
    },
    loading:{
      type: Boolean,
      default: false
    },
    title: {
      type: Object,
      default: () => ({
        en: '',
        es: '',
        he: '',
        ru: '',
        it: ''
      })
    },
  },
  data(){
    return{
      rules,
      screener:{
        title: this.title,
        vod_availability: this.DEFINES.VOD_EVENT_DEFAULT_AVAILABILITY,
        is_vod_event: this.is_vod_event,
        screening_starts_at: null,
        screening_ends_at: null,
      }
    }
  },
  watch:{
    /** Emitting whole Objs once overrides actual obj in paraent */
    "screener.title": {
      handler(newTitle) {
        this.$emit("update:title", newTitle);
      },
      deep: true
    },
    "screener.screening_starts_at"(){
      this.$emit("update:screening_starts_at",this.screener.screening_starts_at);
    },
    "screener.screening_ends_at"(){
      this.$emit("update:screening_ends_at",this.screener.screening_ends_at);
    },
    "screener.vod_availability"(){
      this.$emit("update:vod_availability",this.screener.vod_availability);
    }
  },
  components: {
    DateTimePicker,
    ShowLocalTime,
  },
  computed: {
    ...mapGetters("company", {
      timezone: "getSelectedCompanyTimezone",
    }),
  },
  methods:{
    validateSchedule() {
      if (
        this.screener.screening_starts_at >= this.screener.screening_ends_at
      ) {
        this.$store.dispatch("app/showMessage", {
          message: this.$t("screener.save.screening_date_validation"),
          color: "error",
        });
        return false;
      }
      return true;
    },
    onCreate(){
      if (!this.$refs.form.validate() || (!this.is_vod_event && !this.validateSchedule())) {
        return false;
      }
      this.$emit("onConfirm")
    },
    onCancel(){
      this.$refs.form.reset();
      this.$emit('onCancel');
    }
  }
}
</script>

<style>

</style>
